export default __webpack_public_path__ + "static/media/2-2.90b3ba06.png";